<tilby-dialog-toolbar mat-dialog-title
    (confirm)="confirm()"
    [hideConfirm]="!_form?.valid"
    [title]="'Fattura elettronica'"
/>
<tilby-dialog-content>
    @if(_form) {
        <tilby-magic-form [form]="_form"/>
    }
</tilby-dialog-content>